export const REDIRECT = "redirect"
export const INIT = "init";

export const TENANT = {
    INIT: "init_tenant",
    ADD: "add_tenant",
    API_INIT: "tenant_api_init",
    API_PROCESSING: "tenant_api_inproces",
    API_READY: "tenant_api_ready",
    API_SAVE: "tenant_api_save",
    API_DELETE: "tenant_api_delete",
    VIEW_OVERVIEW: "tenant_overview",
    VIEW_DETAIL: "tenant_detailview",
    VIEW_NEW: "tenant_newview",
    VIEW_EDIT: "tenant_editview",
    ACTION_STORE: "tenant_store",
    API_AUTHORISE_DROPBOX_WITH_CODE: "API_AUTHORISE_DROPBOX_WITH_CODE",
    API_UPDATE_DROPBOX: "API_UPDATE_DROPBOX",
    API_DISCONNECT_DROPBOX_ACCOUNT: "API_DISCONNECT_DROPBOX_ACCOUNT",    
}

export const ADMINUSER = {
    INIT: "init_adminuser",
    API_INIT: "adminuser_api_init",
    API_PROCESSING: "tenant_api_inproces",
    API_READY: "tenant_api_ready",
    API_ERROR: "api_error",
    API_SAVE: "tenant_api_save",
    API_DELETE: "tenant_api_delete",
    LOAD_USERS: "LOAD_USERS",
    LOAD_USER: "LOAD_USER",
    STORE: "STORE",
    VIEW_OVERVIEW: "tenant_overview",
    VIEW_DETAIL: "tenant_detailview",
    VIEW_EDIT: "tenant_editview",
    ACTION_STORE: "tenant_store"    
}

export const TIME_REGISTRATION = {
    INIT: "INIT",
    START_TIMER: "start_timer",
    PAUSE_TIMER: "pause_timer",
    STOP_TIMER: "stop_timer",
    OPEN_REGISTRATION_POPUP: "open_registration_popup",
    LOAD_TIME_REGISTRATIONS: "load_time_registration",
    SAVE_TIME_REGISTRATION: "save_time_registration",
    DELETE_TIME_REGISTRATION: "delete_time_registration",
    NEXT_PAGE: "next_page",
    PREV_PAGE: "prev_page",
    EXPORT: "Export"
}

export const MODAL_POPUP_TYPES = {
    STORE_CONFIRM: "STORE_CONFIRM",
    REMOVE_CONFIRM: "remove_confirm",
    EXPORT_SUCCES_INFO: "export_succes_info",
    ADD_INVOICE_ROW: "add_invoice_row",
    SETTINGS_SET_STORAGE_BASEMAP: "SETTINGS_SET_STORAGE_BASEMAP",
    ADD_DOCUMENT: "ADD_DOCUMENT",
    SEARCH_WORKPROCESS: "SEARCH_WORKPROCESS",
    ADD_CALENDER_ITEM: "ADD_CALENDER_ITEM",
    SHOW_VIDEO: "SHOWVIDEO",
    DETAIL_DOSSIER: "DETAIL_DOSSIER",
    ADD_WORKLOG: "ADD_WORKLOG",
    CLOSE_TASK: "CLOSE_TASK"
}

export const MODAL_POPUP_EVENTS = {
    REMOVE_CONFIRM_BUTTON: "remove_confirm_button",
}

export const INVOICE = {
    API_INIT: "api_init",
    API_CREATE_NEW: "api_create_new",
    API_RECREATE: "api_recreate",
    API_GET_INVOICE_FILTERS: "api_get_invoice_filters",
    API_GET_CUSTOMER_TIMEREG: "api_get_customer_timeregistrations",
    API_PENDING: "api_pending",
    API_SUCCES: "api_succes",
    API_FAILED: "ap_failed",
    VIEW_OVERVIEW: "overview",
    VIEW_CREATE: "create",
    IS_INIT: "init",
    IS_LOADING: "is_loading",
    IS_READY: "is_ready",
    
}

export const WP = {
    API_INIT: "wp_api_init",
    API_LOAD_ITEMS: "wp_api_loaditems",
    API_COPY_WP: "wp_api_copy_wp",
    API_PROCESSING: "wp_api_inproces",
    API_READY: "wp_api_ready",
    API_SAVE: "wp_api_save",
    API_DELETE: "wp_api_delete",
    VIEW_OVERVIEW: "wp_overview",
    VIEW_DETAIL: "wp_detailview",
    VIEW_DETAIL_USER: "wp_detail_user",
    VIEW_EDIT: "wp_editview",
    ACTION_STORE: "wp_store"
}

export const TIMER = {
    API_INIT: "timer_api_init",
    API_PROCESSING: "timer_api_inproces",
    API_READY: "timer_api_ready",
    API_SAVE: "timer_api_save",
    API_DELETE: "timer_api_delete",
    API_START_TIMER: "timer_api_start",
    API_STOP_TIMER: "timer_api_stop",
}

export const SCHEDULE = {
    API_INIT: "schedule_api_init",
    API_PROCESSING: "schedule_api_inproces",
    API_READY: "schedule_api_ready",
    API_SAVE: "schedule_api_save",
    API_DELETE: "schedule_api_delete",
    VIEW_OVERVIEW: "schedule_overview",
    VIEW_DETAIL: "schedule_detailview",
    VIEW_DETAIL_USER: "schedule_detail_user",
    VIEW_NEW: "schedule_newview",
    VIEW_EDIT: "schedule_editview",
    ACTION_STORE: "schedule_store",
    GET_SCHEDULES: "get_schedules",
    GET_SCHEDULE: "get_schedule",
    SEARCH_WP: "SEARCH_WP",
    SEARCH_SCHEDULES: "SEARCH_SCHEDULES",
    CREATE_SCHEDULE: "CREATE_SCHEDULE"
}

export const TRANSLATION = {
    API_INIT: "translation_api_init",
    API_PROCESSING: "translation_api_inproces",
    API_READY: "translation_api_ready",
    API_STORE: "translation_api_save",
    LOAD_TRANSLATION: "get_translations",
}

export const WINDOW = {
    CHANGE_LANGUAGE_LABELS: {
        childWindow: "CHANGE_LANGUAGE_LABELS",
        title: "Veranderen van tekst labels",
        //title_edit: "Bewerken bedrijf %s",
        width: 450,
        height: 200,
        resize: false,
        style : {
            minWidth: 450,
            maxWidth: 450,
            minHeight: 300,
            height: 200,
            width: 450,
        }
    }, 
    SETTINGS_COLOR: {
        childWindow: "SETTINGS_COLOR",
        title: "Selecteer kleur",
        //title_edit: "Bewerken bedrijf %s",
        width: 450,
        height: 200,
        resize: false,
        style : {
            minWidth: 450,
            maxWidth: 450,
            minHeight: 300,
            height: 200,
            width: 450,
        }
        }, 
    ADD_COMPANY: {
        childWindow: "ADD_COMPANY",
        title: "Toevoegen van bedrijf",
        title_edit: "Bewerken bedrijf %s",
        style : {
            minWidth: 750,
            minHeight: 400
        }
        }, 
    ADD_PERSON: {
        window: "ADD_PERSON",
        title: "Toevoegen van persoon",
        title_edit: "Bewerken persoon %s",
        width: 750,
        style : {
            minWidth: 750,
            minHeight: 400,
            width: 750,
            height: 550
        }
    }, 
    ADD_WORKER: {
        childWindow: "ADD_WORKER",
        title: "Toevoegen van werker",
        title_edit: "Bewerken werker %s",
        style : {
            minWidth: 750,
            minHeight: 400,
            width: 750,
            height: 550
        }
    }, 
    SEARCH_COMPANY_WORKERS_PERSONS: {
        childWindow: "SEARCH_COMPANY_WORKERS_PERSONS",
        title: "Zoeken",
        resizeElements: ["userPanelView"],
        style : {
            minWidth: 750,
            minHeight: 400,
            width: "90%",
            height: "70%"
            
        }
        }, 
    SEARCH_CUSTOMER_CPERSON: {
        childWindow: "SEARCH_CUSTOMER_CPERSON",
        title: "Zoeken van klant/contact persoon",
        resizeElements: ["userPanelView"],
        style : {
            minWidth: 750,
            minHeight: 400,
            width: "90%",
            height: "70%"
            
        }
        }, 
        DROPBOX_CONNECT: {
            childWindow: "DROPBOX_CONNECT",
            title: "Dropbox connect",
            resize: false,
            resizeElements: ["dropboxView"],
            style : {
                minWidth: 750,
                minHeight: "70%",
                maxWidth: 750,
                width: "750px",
                height: "70%"
                
            }
            }, 
    CREATE_DOSSIER: {
        childWindow: "CReATE_DOSSIER",
        title: "Nieuw dossier aanmaken vanuit een werkproces",
        startWidth: 1350,
        startHeight: 850,
        style : {
//            minWidth: 1250,
//            minHeight: 700
        }
    }, 
    WORKHOURS_ITEM_EDIT: "WORKHOURS_ITEM_EDIT",
    TODO_WINDOW:     {
            childWindow: "TODO_WINDOW",
            title: "Toevoegen van todo",
            title_edit: "Bewerken todo %s",
            style : {
                width: 750,
                height: 850
            }
           },
    ADDRES_WINDOW:     {
            childWindow: "ADDRESS_WINDOW",
            title: "Adres gegevens",
            title_edit: "Bewerken adres %s",
            style : {
                width: 750,
                height: 850
            }
           },
   CONTACT_WINDOW:     {
           childWindow: "CONTACT_WINDOW",
           title: "Toevoegen van contact",
           title_edit: "Bewerken contact %s",
           style : {
               width: 750,
               height: 850
           }
          },
      APPOINTMENT_WINDOW:     {
              childWindow: "APPOINTMENT_WINDOW",
              title: "Toevoegen van afspraak",
              title_edit: "Bewerken afspraak %s",
              style : {
                  width: 750,
                  height: 850
              }
             },
           
    TODO_WINDOW_SETTINGS: {
        width: 750,
        title: 'TODO',
    }
}

export const DOSSIER = {
    API_INIT: "dossier_api_init",
    API_PROCESSING: "dossier_api_inproces",
    API_READY: "dossier_api_ready",
    API_SAVE: "dossier_api_save",
    API_DELETE: "dossier_api_delete",
    VIEW_OVERVIEW: "dossier_overview",
    VIEW_DETAIL: "dossier_detailview",
    VIEW_DETAIL_USER: "dossier_detail_user",
    VIEW_NEW: "dossier_newview",
    VIEW_EDIT: "dossier_editview",
    VIEW_VIEW: "dossier_viewview",
    ACTION_STORE: "dossier_store",
    GET_DOSSIERS: "get_dossiers",
    GET_DOSSIER: "GET_DOSSIER",
    VIEW_DOSSIER: "view_dossier",
    SEARCH_WP: "SEARCH_WP",
    SEARCH_DOSSIERS: "SEARCH_DOSSIERS",
    INIT_DOSSIER: "INIT_DOSSIER",
    CREATE_DOSSIER: "CREATE_DOSSIER",
    QUICK_SEARCH: "QUICK_SEARCH",
    STORE_WORKLOG: "STORE_WORKLOG",
    CLOSE_TASK: "CLOSE_TASK",
    GET_ALL_DESCRIPTIONS: "GET_ALL_DESCRIPTIONS",
}

export const COMCYCLE = {
    API_INIT: "com_api_init",
    API_NEWITEM: "com_api_newitem",
    API_PROCESSING: "com_api_inproces",
    API_READY: "com_api_ready",
    API_REFRESH: "com_api_refresh",
    API_SAVE: "com_api_save",
    API_DELETE: "com_api_delete",
    VIEW_OVERVIEW: "com_overview",
    VIEW_DETAIL: "com_detailview",
    VIEW_DETAIL_USER: "com_detail_user",
    VIEW_NEW: "com_newview",
    VIEW_EDIT: "com_editview",
    ACTION_STORE: "com_store",
    GET_TASKS: "GET_TASKS",
    GET_com: "get_com",
    SEARCH_WP: "SEARCH_WP",
    CREATE_TASK: "CREATE_TASK"
}

export const PROSPECT = {
    API_INIT: "prospect_api_init",
    API_NEWITEM: "prospect_api_newitem",
    API_PROCESSING: "prospect_api_inproces",
    API_READY: "prospect_api_ready",
    API_REFRESH: "prospect_api_refresh",
    API_SAVE: "prospect_api_save",
    API_DELETE: "prospect_api_delete",
    VIEW_OVERVIEW: "com_overview",
    VIEW_DETAIL: "com_detailview",
    VIEW_DETAIL_USER: "com_detail_user",
    VIEW_NEW: "com_newview",
    VIEW_EDIT: "com_editview",
    ACTION_STORE: "com_store",
    GET_TASKS: "GET_TASKS",
    GET_com: "get_com",
    SEARCH_WP: "SEARCH_WP",
    CREATE_TASK: "CREATE_TASK"
}



export const ROLES = {
    API_INIT: "roles_api_init",
    API_PROCESSING: "roles_api_inproces",
    API_READY: "roles_api_ready",
    API_SAVE: "roles_api_save",
    API_DELETE: "roles_api_delete",
    VIEW_OVERVIEW: "roles_overview",
    VIEW_DETAIL: "roles_detailview",
    VIEW_DETAIL_USER: "roles_detail_user",
    VIEW_EDIT: "roles_editview",
    ACTION_STORE: "roles_store"
}

export const FILES = {
    API_INIT: "files_init",
    API_GET_FILES_FOR_MAP: "API_GET_FILES_FOR_MAP",
    API_RELOAD: "files_reload",
    API_PENDING: "files_api_pending",
    API_READY: "files_api_ready",
    API_ERROR: "files_api_error",
    API_SAVE: "files_api_save",
    API_DOWNLOAD: "files_api_download",
    API_DELETE: "API_DELETE",
}

export const SETTINGS = {
    API_INIT: "settings_api_init",
    API_PENDING: "settings_api_pending",
    API_READY: "settings_api_ready",
    API_ERROR: "settings_api_error",
    API_SAVE: "settings_api_save",
    API_SAVE_BASE_SETTINGS: "basesettings_api_save",
    API_REMOVE_BASE_SETTING: "remove_bse_setting",
    API_GET_PREVIEW_INVOICE: "api_get_preview_invoice",
    API_AUTHORISE_DROPBOX_WITH_CODE: "api_authorise_dropbox_with_code",
    API_SET_STORAGE_BASEMAP: "API_SET_STORAGE_BASEMAP",
    API_DISCONNECT_DROPBOX_ACCOUNT: "API_DISCONNECT_DROPBOX_ACCOUNT",
    VIEW_OVERVIEW: "settings_overview",
    VIEW_SETTINGS_INVOICE: "settings_invoice"
}
export const DOCUMENT = {
    NEW: "new_document",
    DELETE: "delete_document",
    GET_USER_DOCS: "GET_USER_DOCS",
    API_INIT: "init",
    }

export const APP_STATE = {
    INIT: "applcaition_state_init",
    LOADING_APP: "application_loading_state",
    READY_APP: "application_ready",
    LOADING_VIEW: "applocation_loading_view",
    LOGIN_PART: "application_login",
    DASHBOARD_PART: "application_dashboard",
    API_INIT: 1,
    API_PENDING: 2,
    API_READY: 4,
    API_ERROR: 8,
    APP_VIEW_INIT: 1,
    APP_VIEW_DETAIL: 2,
    APP_VIEW_NEW: 4,
    APP_VIEW_EDIT: 8,
}

export const COMPANY_CHECK = {
    API_INIT: "com_api_init",
    API_PROCESSING: "com_api_inproces",
    API_KVK_CHECK: "API_KVK_CHECK",
    API_READY: "com_api_ready",
    API_REFRESH: "com_api_refresh",
    API_SAVE: "com_api_save",
    API_DELETE: "com_api_delete",
    VIEW_OVERVIEW: "com_overview",
    VIEW_DETAIL: "com_detailview",
    VIEW_DETAIL_USER: "com_detail_user",
    VIEW_NEW: "com_newview",
    VIEW_EDIT: "com_editview",
    ACTION_STORE: "com_store",
    GET_TASKS: "GET_TASKS",
    GET_com: "get_com",
    SEARCH_WP: "SEARCH_WP",
    CREATE_TASK: "CREATE_TASK"
}
